import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import api from '../../api/axiosConfig';


// const Signup = () => {
//   // const navigate = useNavigate();
//   const [inputValue, setInputValue] = useState({
//     email: "",
//     password: "",
//     username: "",
//   });
//   const { email, password, username } = inputValue;
//   const handleOnChange = (e) => {
//     const { name, value } = e.target;
//     setInputValue({
//       ...inputValue,
//       [name]: value,
//     });
//   };

//   const handleError = (err) =>
//     toast.error(err, {
//       position: "bottom-left",
//     });
//   const handleSuccess = (msg) =>
//     toast.success(msg, {
//       position: "bottom-right",
//     });

// const handleSubmit = async (event) => {
//     event.preventDefault();
//     // const name = event.target.name.value;
//     // const email = event.target.email.value;
//     // const password = event.target.password.value;

//     try {
//       // Use your configured 'api' instance to call the /signup endpoint
//       const { data } = await api.post('/signup', { 
//         username, 
//         email, 
//         password 
//       });

//       // Check for the success property from your backend response
//       if (data.success && data.token) {
//         localStorage.setItem("authToken", data.token);
//         // Redirect to the dashboard. The browser now has the auth cookie.
//         // window.location.href = 'https://d-pravah-dashboard.vercel.app';
//         window.location.href = `https://d-pravah-dashboard.vercel.app/?token=${data.token}`;
//       } else {
//         alert(data.message|| "SignUp Failed."); // Show error message from backend (e.g., "User already exists")
//       }
//     } catch (error) {
//       console.error('Signup failed:', error);
//       handleError('Signup failed. Please try again.');
//     }
//   };

const Signup = () => {
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
    username: "",
  });
  const { email, password, username } = inputValue;
  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleError = (err) =>
    toast.error(err, {
      position: "bottom-left",
    });
  const handleSuccess = (msg) =>
    toast.success(msg, {
      position: "bottom-right",
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        "https://d-pravah-backend.vercel.app/signup",
        {
          ...inputValue,
        },
        { withCredentials: true }
      );
      const { success, message } = data;
      if (success) {
        handleSuccess(message);
        setTimeout(() => {
         window.location.href = "https://d-pravah-dashboard.vercel.app/"; 
        }, 1000);
      } else {
        handleError(message);
        setInputValue({
      ...inputValue,
      email: "",
      password: "",
      username: "",
    });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="form_container">
      <h2>Signup Account</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            name="email"
            value={email}
            placeholder="Enter your email"
            onChange={handleOnChange}
          />
        </div>
        <div>
          <label htmlFor="email">Username</label>
          <input
            type="text"
            name="username"
            value={username}
            placeholder="Enter your username"
            onChange={handleOnChange}
          />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            value={password}
            placeholder="Enter your password"
            onChange={handleOnChange}
          />
        </div>
        <button type="submit">Submit</button>
        <span>
          Already have an account? <Link to={"/login"}>Login</Link>
        </span>
      </form>
      <ToastContainer />
    </div>
  );
};

export default Signup;